import { Component, Input, OnInit } from '@angular/core';

import { IPromosEcommerce } from '../../../private/shared/models/productos';

@Component({
  selector: 'app-promo-present',
  templateUrl: './promo-present.component.html',
  styleUrls: ['./promo-present.component.scss'],
})
export class PromoPresentComponent implements OnInit {

  @Input() promo: IPromosEcommerce;

  constructor() { }

  ngOnInit() {}

}
